export default {"src":"/_next/static/media/linked-in.4ca6a304.svg","height":20,"width":20};